import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrDownloadProfileInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-download', title: 'ITR Download Profile', subtitle: 'Initiate download of ITR profile data' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/itr/download-profile',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-download-profile"
        submitLabel="Download Profile"
        successSummary="ITR profile download initiated"
        errorSummary="Profile download failed"
        confirmHeader="Confirm profile download"
        confirmAcceptLabel="Yes, download"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Profile Download', icon: 'pi-download' }}
    />
);

export default ItrDownloadProfileInputComponent;
